/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type SbSharedRefineMenuTypeahead_viewer = {|
  +facetSearch?: ?{| |};
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "searchString",
      "type": "String",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "facetName",
      "type": "String",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "hasQuery",
      "type": "Boolean",
      "defaultValue": false
    },
    {
      "kind": "RootArgument",
      "name": "uriRef",
      "type": "String"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedRefineMenuTypeahead_viewer",
  "selections": [
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "hasQuery",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "facetName",
              "variableName": "facetName",
              "type": "String"
            },
            {
              "kind": "Literal",
              "name": "first",
              "value": 5,
              "type": "Int"
            },
            {
              "kind": "Literal",
              "name": "page",
              "value": 1,
              "type": "Int"
            },
            {
              "kind": "Variable",
              "name": "searchString",
              "variableName": "searchString",
              "type": "String"
            },
            {
              "kind": "Variable",
              "name": "uriRef",
              "variableName": "uriRef",
              "type": "String"
            }
          ],
          "concreteType": "FacetsQueryConnection",
          "name": "facetSearch",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "SbSharedRefineMenuSearchResults_facetSearch",
              "args": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Viewer"
};

module.exports = fragment;
